import {VALUES} from '../../constants/values'

export function GhostActor(): JSX.Element {
  return <span>{VALUES.ghostUserLogin} </span>
}

try{ GhostActor.displayName ||= 'GhostActor' } catch {}